import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/app/config/environments/environment';
import { ChannelParamsDto } from '../dto/channel-params.dto';
import { Channel } from '../models/channel.interface';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ChannelsService {
  private readonly path = 'channels';

  constructor(private readonly http: HttpClient) {}

  getAll(params?: ChannelParamsDto): Observable<Channel[]> {
    const url = `${environment.api.baseUrl}/${this.path}`;
    const httpParams = this.buildHttpParams(params);
    return this.http
      .get<Channel[]>(url, { params: httpParams })
      .pipe((response) => response);
  }

  getById(id: string): Observable<Channel> {
    return this.http.get<Channel>(
      `${environment.api.baseUrl}/${this.path}/${id}`
    );
  }

  getByEmployee(params?: ChannelParamsDto): Observable<Channel[]> {
    const url = `${environment.api.baseUrl}/${this.path}?employee`;
    const httpParams = this.buildHttpParams(params);
    return this.http
      .get<Channel[]>(url, { params: httpParams })
      .pipe((response) => response);
  }

  create(channel: Channel): Observable<String> {
    return this.http.post(`${environment.api.baseUrl}/${this.path}`, channel, {
      responseType: 'text',
    });
  }

  update(channel: Channel): Observable<string> {
    return this.http.put(
      `${environment.api.baseUrl}/${this.path}/${channel.id}`,
      channel,
      { responseType: 'text' }
    );
  }

  delete(id: string): Observable<any> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.path}/disable/${id}`,
      {}
    );
  }

  private buildHttpParams(params?: ChannelParamsDto): HttpParams {
    let httpParams = new HttpParams();

    if (params?.idSchool && params?.idSchool != '') {
      httpParams = httpParams.set('idSchool', params?.idSchool);
    }

    if (params?.idsClassRooms && params?.idsClassRooms.length > 0) {
      const idsClassRooms = params.idsClassRooms.join(',');

      httpParams = httpParams.set('idsClassRooms', idsClassRooms);
    }

    return httpParams;
  }
}
